import { createModel } from 'xstate/lib/model';

import {
  SubscriptionModelWithCoupons,
  UpdateSubscriptionEvent,
  GetSubscriptionDetailsEvent,
  Coupon,
} from './types';

const subscriptionModel = createModel(
  {
    id: null,
    coupons: [],
    status: 'active',
    currency: 'USD',
    scheduledCancellationAt: null,
    currentBillingAmountInCents: 0,
    productFamilyId: null,
    expiresAt: null,
    automaticallyResumeAt: null,
    trialEndedAt: null,
    canceledAt: null,
    currentPeriodEndsAt: null,
    nextAssessmentAt: null,
    nextProductId: null,
    balanceInCents: 0,
    referralCode: null,
    threeDsActionLink: null,
    product: {
      id: null,
      name: '',
      description: null,
      priceInCents: 0,
      interval: 0,
      intervalUnit: null,
      trialPriceInCents: 0,
      trialInterval: null,
      trialIntervalUnit: null,
    },
    components: {
      updatesAllowed: null,
      usedInBilling: null,
    },
    billing: {
      paymentProfileConnected: false,
      paymentProfileId: null,
      address: {
        address: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        country: null,
      },
      creditCard: {
        firstName: null,
        lastName: null,
        cardType: null,
        maskedNumber: null,
        expirationMonth: 0,
        expirationYear: 0,
      },
      bankAccount: {
        maskedAccountNumber: null,
        maskedRoutingNumber: null,
        bankName: null,
        firstName: null,
        lastName: null,
      },
    },
    error: null,
    addedCoupon: null,
  } as unknown as SubscriptionModelWithCoupons,
  {
    events: {
      UPDATE_SUBSCRIPTION: (event: UpdateSubscriptionEvent) => event,
      GET_SUBSCRIPTION_DETAILS: (event: GetSubscriptionDetailsEvent) => ({
        event,
      }),
      GET_COUPONS: (event: GetCouponsEvent) => ({ coupons: event.coupons }),
      ADD_COUPON: (event: AddCouponEvent) => ({ couponCode: event.couponCode }),
      ADD_ANOTHER_COUPON: () => ({}),
    },
  }
);

export type AddCouponEvent = {
  type: 'ADD_COUPON';
  couponCode: string;
};

export type GetCouponsEvent = {
  type: 'GET_COUPONS';
  coupons: Coupon[];
};

export type GetCouponsSuccessEvent = {
  type: 'GET_COUPONS_SUCCESS';
  data: SubscriptionModelWithCoupons;
};

export type AddAnotherCouponEvent = {
  type: 'ADD_ANOTHER_COUPON';
};

export default subscriptionModel;
